import angular from 'angular';
import informationManagementComponent from './information-management.component';

let informationManagementModule = angular.module('informationManagement', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('informationManagement', informationManagementComponent);

export default informationManagementModule;



// WEBPACK FOOTER //
// ./client/pages/admin/information-management/information-management.js